import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

import { DISCLAIMER_CONSULTATION_RESULTS_INGREDIENTS_CANCEL } from 'consts/copy';

import { SIMPLE_HERO_LAYOUT, type SimpleHeroProps } from '../SimpleHero';

export const SIMPLE_HERO_NIACINAIDE_CONTENT: SimpleHeroProps = {
  header: (
    <React.Fragment>
      Niacinamide for <br />
      stronger, brighter skin
    </React.Fragment>
  ),
  body: 'Repair, restore, rebuild—niacinamide’s here to undo damage and help your skin thrive. This fortifying ingredient helps keep skin clear, calm, and smooth.',
  ctaButton: {
    buttonText: 'Get your custom formula',
    disclaimerText: DISCLAIMER_CONSULTATION_RESULTS_INGREDIENTS_CANCEL,
  },
  media: (
    <StaticImage
      src="../images/headerNiacinamideDesktop@2x.jpg"
      alt="woman putting on custom formula"
      loading="eager"
    />
  ),
  layout: SIMPLE_HERO_LAYOUT.imageLast,
};
